/**
 * La vibration de l'enregistreur de l'oral : celle de l'ancien `AudioRecordingContainer`
 * (`Vibration.vibrate(50)`), à chaque geste sur un enregistrement en cours — la pause, la reprise, la
 * fin (touchée, ou le plafond atteint). Le démarrage ne vibrait pas. Pur.
 */
import { type VoiceRecorderStatus } from "../../../../../../engine/voice/voiceRecorderMachine"

export const RECORDER_VIBRATION_MS = 50

export function recorderVibrates(previous: VoiceRecorderStatus | null, next: VoiceRecorderStatus): boolean {
    if (previous == null || previous === next) return false
    const wasLive = previous === "recording" || previous === "paused"
    return wasLive && (next === "recording" || next === "paused" || next === "recorded")
}
